import React, { useState } from "react";
import { Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import PreviewModal from "../../pages/surveyBuilder/v2/viewer/Preview/PreviewComponents/PreviewModal";

import "./DescriptionWithButton.scss";

const DescriptionWithButton = React.memo(({ description, title, textColor }) => {
   const trimmedText = (description || "").trim();
   const CHAR_LIMIT = 100;
   const showButton = trimmedText.length > CHAR_LIMIT;

   const [isModalOpen, setIsModalOpen] = useState(false);

   const handleToggleModal = () => {
      setIsModalOpen((prev) => !prev);
   };

   return (
      <div className="read-more">
         {showButton && (
            <Button
               type="text"
               className="read-more__button"
               style={{ color: textColor }}
               onClick={handleToggleModal}
            >
               Read more <RightOutlined />
            </Button>
         )}

         {isModalOpen && (
            <PreviewModal
               hasCloseButton
               title={title}
               isModalOpen={isModalOpen}
               setIsModalOpen={handleToggleModal}
            >
               <div dangerouslySetInnerHTML={{ __html: trimmedText.replace(/\n/g, "<br />") }} />
            </PreviewModal>
         )}
      </div>
   );
});

export default DescriptionWithButton;
